import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import "sweetalert2/dist/sweetalert2.min.css";
import "../components/Table/Table.css";
import TopLoader from "../components/Loader/TopLoader";
import "react-responsive-modal/styles.css";
import { Modal, Button } from "@mui/material";
import { toast } from "react-toastify";
import {
  addStudent,
  get_hostel_type_from_udise,
  get_school_name_gmid,
  get_category_for_student,
  get_sub_category_for_student_by_caste,
  getAllBlocksFromDistrict,
  getVillageFromGpBlockAndDistrict,
  getGPFromDistrictAndBlock,
} from "../api/Users";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "../api/constant";
import { MDBTypography } from "mdb-react-ui-kit";
import adhaarImg from "../images/adhaar.png";
import { Image } from "react-bootstrap";

const AddStudent = ({ userData }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const { t } = useTranslation();
  const {
    formState: { errors },
  } = useForm();

  const [loading, setLoading] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const rowData = location.state;
  const [castes, setCastes] = useState([]);
  const [Subcastes, setSubCastes] = useState([]);
  const [Allblocks, setAllBlocks] = useState([]);
  const [Block, setBlock] = useState("");
  const [districtDropdown, setDistrictDropdown] = useState("");
  const [Alldistricts, setAllDistricts] = useState([]);
  const [Village, setVillage] = useState("");
  const [GP, setGP] = useState("");
  const [AllGPs, setAllGPs] = useState([]);
  const [Allvillages, setAllVillages] = useState([]);

  useEffect(() => {
    axios
      .get("/get_all_districts")
      .then((response) => {
        if (response.data.status == "success") {
          setAllDistricts(response.data.data);
        } else {
          setAllDistricts([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching districts:", error);
      });
  }, []);

  const [student, setStudent] = useState({
    name: "",
    class: "",
    date_of_birth: "",
    gender: "",
    caste: "",
    sub_caste: 0,
    res_status: "",
    hostel_attached: "",
    school_name: "",
    hostel_type: "",
    father_name: "",
    doj: "",
    mother_name: "",
    guardian_ph_no: "",
    student_aadhaar: "",
    aadhaar1: "",
    aadhaar2: "",
    aadhaar_no: "",
    birth_cert: "",
  });
  const [AllSchoolNames, setAllSchoolNames] = useState([]);
  const [AllHostelTypes, setAllHostelTypes] = useState([]);
  const [error, setErrors] = useState({});

  useEffect(() => {
    setIsLoading(false);
  }, []);

  const [photo, setPhoto] = useState(null);
  const handlePhotoChange = (event) => {
    const file = event.target.files[0];
    if (!file) {
      toast.error("No student photo selected!.");
      return;
    }

    const allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i; // Allowed file types

    // Check if the file is of the allowed type
    if (!allowedExtensions.test(file.name)) {
      toast.error("Invalid file type. Only JPG and PNG files are allowed.");
      event.target.value = "";
      return;
    }
    setPhoto(file);
  };

  const handleChangeInput = (e) => {
    const { name, value, type, files } = e.target;
    if (type !== "file") {
      setStudent((student) => ({ ...student, [name]: value }));
    } else {
      const file = files[0];
      setStudent((student) => ({ ...student, [name]: file }));
    }

    if (name === "caste") {
      let data = {
        Caste_Category: value,
      };
      get_sub_category_for_student_by_caste(data).then((res) => {
        if (res.status === "success") {
          setSubCastes(res.data.student_sub_category);
        }
      });
    }
  };

  useEffect(() => {
    get_category_for_student()
      .then((response) => {
        if (response.status == "success") {
          setCastes(response.data.student_category);
        }
      })
      .catch((error) => {
        console.error("Error fetching villages:", error);
      });

    // Set staff data from rowData when component mounts
    if (rowData) {
      setStudent((prevStaff) => ({
        ...prevStaff,
        ...rowData,
      }));
    }
  }, [rowData]);

  useEffect(() => {
    get_school_name_gmid(userData.data.gm_id)
      .then((response) => {
        if (response.status == "success") {
          setAllSchoolNames(response.data.new_asset_query);
        } else {
          setAllSchoolNames([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching villages:", error);
      });

    const data = {
      UDISE_code: userData.data.UDISE_code,
    };

    get_hostel_type_from_udise(data).then((res) => {
      if (res.status == "success") {
        setAllHostelTypes(res.data.hostelData);
      } else {
        setAllHostelTypes([]);
      }
    });
  }, []);

  const handleDistrictChange = (e) => {
    setDistrictDropdown(e.target.value);
    getAllBlocksFromDistrict(e.target.value)
      .then((res) => {
        if (res.status === "success") {
          console.log("dis data:", res.data);
          setAllBlocks(res.data.new_asset_query);
        }
      })
      .catch((err) => {
        console.error("Error fetching blocks:", err);
      });
  };

  const navigate = useNavigate(); // Initialize navigate function

  const onSubmit = (e) => {
    e.preventDefault();

    const formErrors = {};
    const namePattern = /^[a-zA-Z\s'-]+$/;

    if (photo == null) {
      formErrors.photo_file = "No student photo selected!";
    }

    if (!student.name.trim()) {
      formErrors.name = "Student Name is required";
    } else if (!namePattern.test(student.name)) {
      formErrors.name = " Student name must contain only letters";
    }

    if (!student.class) {
      formErrors.class = "Class is required";
    }

    if (!student.gender) {
      formErrors.gender = "Gender is required";
    }

    if (!student.date_of_birth) {
      formErrors.date_of_birth = "Date of Birth is required";
    }

    if (!student.caste) {
      formErrors.caste = "Caste is required";
    }

    if (!student.sub_caste) {
      formErrors.sub_caste = "Sub Caste is required";
    }

    if (!student.res_status) {
      formErrors.res_status = "Residential Status is required";
    }
    if (student.res_status === "Boarder") {
      if (!student.hostel_attached) {
        formErrors.hostel_attached = "Hostel Ownership is required";
      }

      if (!student.school_name) {
        formErrors.school_name = "School Name is required";
      }

      if (!student.hostel_type) {
        formErrors.hostel_type = "Hostel Type is required";
      }

      if (!student.doj) {
        formErrors.doj = "Date Of Joining is required";
      }
    }

    if (!student.father_name.trim()) {
      formErrors.father_name = "Father's Name is required";
    } else if (!namePattern.test(student.father_name)) {
      formErrors.father_name = "Father's Name must contain only letters";
    }

    if (!student.mother_name.trim()) {
      formErrors.mother_name = "Mother's Name is required";
    } else if (!namePattern.test(student.mother_name)) {
      formErrors.mother_name = "Mother's Name must contain only letters";
    }

    if (!student.guardian_ph_no.trim()) {
      formErrors.guardian_ph_no = "Guardian's Mobile Number is required";
    } else if (!/^\d{10}$/.test(student.guardian_ph_no)) {
      formErrors.guardian_ph_no = "Please enter a valid 10-digit mobile number";
    }

    if (!districtDropdown) {
      formErrors.district = "Domicile District is required";
    }

    if (!Block) {
      formErrors.block = "Domicile Block is required";
    }

    if (!GP) {
      formErrors.GP = "Domicile GP is required";
    }

    if (!Village) {
      formErrors.Village = "Domicile Village is required";
    }

    if (!student.aadhaar_no.trim()) {
      formErrors.aadhaar_no = "Aadhaar Number is required";
    } else if (!/^\d{12}$/.test(student.aadhaar_no)) {
      formErrors.aadhaar_no = "Please enter a valid 12-digit Aadhaar number";
    }

    if (
      student.aadhaar1 == null ||
      student.aadhaar2 == null ||
      student.student_aadhaar == null ||
      student.birth_cert == null
    ) {
      toast.error("Aadhaar upload pending!");
    }

    setErrors(formErrors);

    if (Object.keys(formErrors).length === 0) {
      setIsLoading(true);
      const formData = new FormData();

      // Append each field and its value to the FormData object
      formData.append("student_name", student.name);
      formData.append("class", student.class);
      formData.append("date_of_birth", student.date_of_birth);
      formData.append("gender", student.gender);
      formData.append("caste_category", student.caste);
      formData.append("sub_caste", student.sub_caste);
      formData.append("Boarder_Dayscholar", student.res_status);
      formData.append("hostel_attached_to_school", student.hostel_attached);
      formData.append("If_no_Mention_school_name", student.school_name);
      formData.append("hostel_id", student.hostel_type);
      formData.append("father_name", student.father_name);
      formData.append("joining_date_Boarderel", student.doj);
      formData.append("mother_name", student.mother_name);
      formData.append("Parents_MobileNo", student.guardian_ph_no);
      formData.append("Domicile_District", districtDropdown);
      formData.append("Domicile_Block", Block);
      formData.append("Domicile_Gp", GP);
      formData.append("Domicile_Village", Village);
      formData.append("student_aadhar_card", student.student_aadhaar);
      formData.append("father_aadhar_card", student.aadhaar1);
      formData.append("mother_aadhar_card", student.aadhaar2);
      formData.append("std_aadhar_no", student.aadhaar_no);
      formData.append("student_photo", photo);
      formData.append("student_dob_certificate", student.birth_cert);

      addStudent(formData)
        .then((res) => {
          if (res.status === "success") {
            setIsLoading(false);
            toast.success(t(res.message));
            window.location.reload();
          } else {
            toast.error(t(res.message));
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const back = () => {
    navigate(`/student-details`);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleUpdateClick = (row) => {
    setModalOpen(true);
  };

  const handleBlockChange = (e) => {
    setBlock(e.target.value);
    getGPFromDistrictAndBlock(districtDropdown, e.target.value)
      .then((res) => {
        if (res.status === "success") {
          console.log("dis data:", res.data);
          setAllGPs(res.data.new_asset_query);
        }
      })
      .catch((err) => {
        console.error("Error fetching assets:", err);
      });
  };

  const handleGPChange = (e) => {
    setGP(e.target.value);
    getVillageFromGpBlockAndDistrict(districtDropdown, Block, e.target.value)
      .then((res) => {
        if (res.status === "success") {
          console.log("dis data:", res.data);
          setAllVillages(res.data.new_asset_query);
        }
      })
      .catch((err) => {
        console.error("Error fetching assets:", err);
      });
  };
  const handleVillageChange = (e) => {
    setVillage(e.target.value);
  };

  return (
    <>
      <TopLoader loading={isLoading ? "50" : "100"} />
      <div className="px-2 px-md-4">
        <div className="my-4 col-12 d-flex justify-content-between align-items-center">
          <h5 className="">{t("Add Student Details")}</h5>

          {photo ? (
            <Image
              src={URL.createObjectURL(photo)}
              alt="Uploaded Photo"
              width={100}
              height={100}
              className="mr-4"
            />
          ) : (
            <AccountCircleIcon
              style={{
                width: 100,
                height: 100,
                marginRight: 4,
                background: "#fff",
                color: "whitesmoke",
              }}
            />
          )}
        </div>

        <form
          onSubmit={(e) => onSubmit(e)}
          id="myform"
          style={{ marginTop: "12px" }}
        >
          <div className="row">
            <div className="col-md-4">
              <label className="form-label">
                {t("Student Photo")} {<span style={{ color: "red" }}>*</span>}
              </label>
              <input
                type="file"
                name="photo_file"
                accept=".jpg, .jpeg, .png"
                className="form-control"
                onChange={handlePhotoChange}
              />
              {error.photo_file && (
                <div className="text-danger">{error.photo_file}</div>
              )}
            </div>
            <div className="col-md-4">
              <label className="form-label">
                {t("Student Name")} {<span style={{ color: "red" }}>*</span>}
              </label>
              <input
                type="text"
                name="name"
                className="form-control"
                onChange={handleChangeInput}
                required
              />
              {error.name && <div className="text-danger">{error.name}</div>}
            </div>
            <div className="col-md-4">
              <label className="form-label">
                {t("Class")}
                {<span style={{ color: "red" }}>*</span>}
              </label>
              <select
                name="class"
                onChange={handleChangeInput}
                className="common-input form-select"
                required
              >
                <option value="">Select Class</option>
                <option value="I">I</option>
                <option value="II">II</option>
                <option value="III">III</option>
                <option value="IV">IV</option>
                <option value="V">V</option>
                <option value="VI">VI</option>
                <option value="VII">VII</option>
                <option value="VIII">VIII</option>
                <option value="IX">IX</option>
                <option value="X">X</option>
                <option value="XI">XI</option>
                <option value="XII">XII</option>
              </select>
              {error.class && <div className="text-danger">{error.class}</div>}
            </div>
            <div className="col-md-4 mt-4">
              <label className="form-label">
                {t("Gender")} {<span style={{ color: "red" }}>*</span>}
              </label>
              <select
                name="gender"
                onChange={handleChangeInput}
                className="common-input form-select"
                required
              >
                <option value="">Select Gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
              </select>
              {error.gender && (
                <div className="text-danger">{error.gender}</div>
              )}
            </div>
            <div className="col-md-4 mt-4">
              <label className="form-label">
                {t("Date of Birth")} {<span style={{ color: "red" }}>*</span>}
              </label>
              <input
                type="date"
                name="date_of_birth"
                className="form-control"
                onChange={handleChangeInput}
                required
              />
              {error.date_of_birth && (
                <div className="text-danger">{error.date_of_birth}</div>
              )}
            </div>
            <div className="col-md-4 mt-4">
              <label className="form-label">
                {t("Caste")} {<span style={{ color: "red" }}>*</span>}
              </label>
              <select
                name="caste"
                onChange={handleChangeInput}
                className="common-input form-select"
                required
              >
                <option value="">Select Caste</option>
                {castes.map((caste) => (
                  <option value={caste.Caste_Category}>
                    {caste.Caste_Category}
                  </option>
                ))}
              </select>
              {error.caste && <div className="text-danger">{error.caste}</div>}
            </div>
            <div className="col-md-4 mt-4">
              <label className="form-label">
                {t("Sub Caste")} {<span style={{ color: "red" }}>*</span>}
              </label>
              <select
                name="sub_caste"
                onChange={handleChangeInput}
                className="common-input form-select"
                required
              >
                <option value="">Select Caste</option>
                {Subcastes.map((caste) => (
                  <option value={caste.Sub_Caste}>{caste.Sub_Caste}</option>
                ))}
              </select>
              {error.sub_caste && (
                <div className="text-danger">{error.sub_caste}</div>
              )}
            </div>
            <div className="col-md-4 mt-4">
              <label className="form-label">
                {t("Student Residential Status")}{" "}
                {<span style={{ color: "red" }}>*</span>}
              </label>
              <select
                name="res_status"
                onChange={handleChangeInput}
                className="common-input form-select"
                required
              >
                <option value="">Select Residential Status</option>
                <option value="Day Scholar">Day Scholar</option>
                <option value="Boarder">Boarder</option>
              </select>
              {error.res_status && (
                <div className="text-danger">{error.res_status}</div>
              )}
            </div>
            <div
              className="col-md-4 mt-4"
              style={{
                display: student.res_status == "Boarder" ? "block" : "none",
              }}
            >
              <label className="form-label">
                {t("Hostel Attached To School")}{" "}
                {<span style={{ color: "red" }}>*</span>}
              </label>
              <select
                name="hostel_attached"
                onChange={handleChangeInput}
                className="common-input form-select"
              >
                <option value="">Select Hostel Ownership</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
              {error.hostel_attached && (
                <div className="text-danger">{error.hostel_attached}</div>
              )}
            </div>
            <div
              className="col-md-4 mt-4"
              style={{
                display:
                  student.res_status == "Boarder" &&
                  student.hostel_attached == "No"
                    ? "block"
                    : "none",
              }}
            >
              <label className="form-label">
                {t("School Name")} {<span style={{ color: "red" }}>*</span>}
              </label>
              <select
                name="school_name"
                onChange={handleChangeInput}
                className="common-input form-select"
              >
                <option value="">Select School Name</option>
                {AllSchoolNames &&
                  AllSchoolNames.map((row) => (
                    <option key={row.school_id} value={row.school_id}>
                      {" "}
                      {row.name}
                    </option>
                  ))}
              </select>
              {error.school_name && (
                <div className="text-danger">{error.school_name}</div>
              )}
            </div>
            <div
              className="col-md-4 mt-4"
              style={{
                display: student.res_status == "Boarder" ? "block" : "none",
              }}
            >
              <label className="form-label">
                {t("Hostel Type")} {<span style={{ color: "red" }}>*</span>}
              </label>
              <select
                name="hostel_type"
                onChange={handleChangeInput}
                className="common-input form-select"
              >
                <option value="">Select Hostel Types</option>
                {AllHostelTypes &&
                  AllHostelTypes.map((row) => (
                    <option key={row.hostel_id} value={row.hostel_id}>
                      {" "}
                      {row.hostel_type}
                    </option>
                  ))}
              </select>
              {error.hostel_type && (
                <div className="text-danger">{error.hostel_type}</div>
              )}
            </div>
            <div
              className="col-md-4 mt-4"
              style={{
                display: student.res_status == "Boarder" ? "block" : "none",
              }}
            >
              <label className="form-label">
                {t("Date Of Joining")} {<span style={{ color: "red" }}>*</span>}
              </label>
              <input
                type="date"
                name="doj"
                className="form-control"
                onChange={handleChangeInput}
              />
              {error.doj && <div className="text-danger">{error.doj}</div>}
            </div>
            <div className="col-md-4 mt-4">
              <label className="form-label">
                {t("Father Name")} {<span style={{ color: "red" }}>*</span>}
              </label>
              <input
                onChange={handleChangeInput}
                type="text"
                name="father_name"
                className="form-control"
                required
              />
              {error.father_name && (
                <div className="text-danger">{error.father_name}</div>
              )}
            </div>
            <div className="col-md-4 mt-4">
              <label className="form-label">
                {t("Mother Name")} {<span style={{ color: "red" }}>*</span>}
              </label>
              <input
                onChange={handleChangeInput}
                type="text"
                name="mother_name"
                className="form-control"
                required
              />
              {error.mother_name && (
                <div className="text-danger">{error.mother_name}</div>
              )}
            </div>
            <div className="col-md-4 mt-4">
              <label className="form-label">
                {t("Parents/Guardian Mobile No.")}{" "}
                {<span style={{ color: "red" }}>*</span>}
              </label>
              <input
                onChange={handleChangeInput}
                type="text"
                pattern="[0-9]*"
                name="guardian_ph_no"
                className="form-control"
                required
                maxLength={10}
              />
              {error.guardian_ph_no && (
                <div className="text-danger">{error.guardian_ph_no}</div>
              )}
            </div>
            <div className="col-md-4 mt-4">
              <label className="form-label">
                {t("Domicile District")}{" "}
                {<span style={{ color: "red" }}>*</span>}
              </label>
              <select
                name="domicile_district"
                className="common-input form-select"
                onChange={handleDistrictChange}
              >
                <option value="" selected={true}>
                  {t("Select District")}
                </option>
                {Alldistricts &&
                  Alldistricts.map((row) => (
                    <option key={row.district_code} value={row.district_code}>
                      {" "}
                      {row.name}
                    </option>
                  ))}
              </select>
              {error.domicile_district && (
                <div className="text-danger">{error.domicile_district}</div>
              )}
            </div>
            <div className="col-md-4 mt-4">
              <label className="form-label">
                {t("Domicile Block")} {<span style={{ color: "red" }}>*</span>}
              </label>
              <select
                name="domicile_block"
                className="common-input form-select"
                onChange={handleBlockChange}
                required
              >
                <option value="">{t("Select Block")}</option>
                {Allblocks &&
                  Allblocks.map((row, index) => (
                    <option key={index} value={row.code}>
                      {row.name}
                    </option>
                  ))}
              </select>
              {error.domicile_block && (
                <div className="text-danger">{error.domicile_block}</div>
              )}
            </div>
            <div className="col-md-4 mt-4">
              <label className="form-label">
                {t("Domicile GP")} {<span style={{ color: "red" }}>*</span>}
              </label>
              <select
                name="domicile_gp"
                className="common-input form-select"
                onChange={handleGPChange}
                required
              >
                <option value="">{t("Select GP")}</option>
                {AllGPs &&
                  AllGPs.map((row, index) => (
                    <option key={index} value={row.code}>
                      {row.name}
                    </option>
                  ))}
              </select>
              {error.domicile_gp && (
                <div className="text-danger">{error.domicile_gp}</div>
              )}
            </div>
            <div className="col-md-4 mt-4">
              <label className="form-label">
                {t("Domicile Village")}{" "}
                {<span style={{ color: "red" }}>*</span>}
              </label>
              <select
                name="domicile_village"
                className="common-input form-select"
                onChange={handleVillageChange}
                required
              >
                <option value="">{t("Select Village Name")}</option>
                {Allvillages &&
                  Allvillages.map((row, index) => (
                    <option key={index} value={row.gm_id}>
                      {row.village_name}
                    </option>
                  ))}
              </select>
              {error.domicile_village && (
                <div className="text-danger">{error.domicile_village}</div>
              )}
            </div>
            <div className="col-md-4 mt-4">
              <label className="form-label">
                {t("Student Aadhaar Number")}{" "}
                {<span style={{ color: "red" }}>*</span>}
              </label>
              <input
                onChange={handleChangeInput}
                type="text"
                name="aadhaar_no"
                className="form-control"
                maxLength={12}
                required
              />
              {error.aadhaar_no && (
                <div className="text-danger">{error.aadhaar_no}</div>
              )}
            </div>
            <div className="col-md-4 mt-4">
              <label className="form-label d-flex justify-content-center">
                {t("Add Documents (PDF only)")}{" "}
                {<span style={{ color: "red" }}>*</span>}
              </label>
              <div className="d-flex justify-content-center">
                <button
                  type="button"
                  className="btn btn-secondary col-md-8"
                  onClick={handleUpdateClick}
                >
                  Add
                </button>
              </div>
            </div>
          </div>

          <div className="row col-12 mt-5 d-flex justify-content-end">
            <button type="submit" className="btn btn-primary me-2 col-md-2">
              {t("Save")}
            </button>

            <button
              type="submit"
              className="btn btn-secondary me-2 col-md-2"
              onClick={back}
            >
              {t("Back")}
            </button>
          </div>

          <Modal
            open={modalOpen}
            onClose={handleCloseModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: 1000,
                backgroundColor: "#ffffff",
                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                borderRadius: 8,
                padding: 20,
              }}
            >
              {" "}
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={handleCloseModal}
                style={{
                  position: "absolute",
                  top: 10,
                  right: 10,
                  background: "none",
                  border: "none",
                  fontSize: 24,
                  cursor: "pointer",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="currentColor"
                  className="bi bi-x"
                  viewBox="0 0 16 16"
                >
                  <path d="M3.854 3.146a.5.5 0 0 1 .708 0L8 7.293l3.646-3.647a.5.5 0 1 1 .708.708L8.707 8l3.647 3.646a.5.5 0 1 1-.708.708L8 8.707l-3.646 3.647a.5.5 0 1 1-.708-.708L7.293 8 3.646 4.354a.5.5 0 0 1 0-.708z" />
                </svg>
              </button>
              <div className="row mt-4 mb-2">
                <div className="row">
                  <div className="col-6">
                    <Image src={adhaarImg} height="300px" />
                  </div>
                  <div className="col-6">
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <MDBTypography tag="h5" className="mb-4">
                          Add Documents (PDF only)
                        </MDBTypography>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6 my-3">
                        <label className="form-label">
                          Student's Aadhaar
                          <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="file"
                          name="student_aadhaar"
                          accept=".pdf"
                          className="form-control"
                          onChange={handleChangeInput}
                        />
                        {student.student_aadhaar && (
                          <p className="text-primary">
                            Selected file: {student.student_aadhaar.name}
                          </p>
                        )}
                      </div>
                      <div className="col-md-6 my-3">
                        <label className="form-label">Father's Aadhaar</label>
                        <input
                          type="file"
                          name="aadhaar1"
                          accept=".pdf"
                          className="form-control"
                          onChange={handleChangeInput}
                        />
                        {student.aadhaar1 && (
                          <p className="text-primary">
                            Selected file: {student.aadhaar1.name}
                          </p>
                        )}
                      </div>
                      <div className="col-md-6 my-3">
                        <label className="form-label">Mother's Aadhaar</label>
                        <input
                          type="file"
                          name="aadhaar2"
                          accept=".pdf"
                          className="form-control"
                          onChange={handleChangeInput}
                        />
                        {student.aadhaar2 && (
                          <p className="text-primary">
                            Selected file: {student.aadhaar2.name}
                          </p>
                        )}
                      </div>
                      <div className="col-md-6 my-3">
                        <label className="form-label">
                          Student's Birth Certificate
                        </label>
                        <input
                          type="file"
                          name="birth_cert"
                          accept=".pdf"
                          className="form-control"
                          onChange={handleChangeInput}
                        />
                        {student.aadhaar2 && (
                          <p className="text-primary">
                            Selected file: {student.birth_cert.name}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal>
        </form>
      </div>
    </>
  );
};

export default AddStudent;
